import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import '../css/ActiveUserDisplay.css';
import { useActiveUsers } from '../utilities/ActiveUsersProvider';
import { useEmail } from '../utilities/http/routing/EmailContext';

type UserStatusMap = {
  [email: string]: [boolean, string];
};

export const ActiveUserDisplay: React.FC = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const  {activeUsers}  = useActiveUsers();
  const {userEmail} = useEmail()

  if (!activeUsers) {
    return (
      <div className="active-user-display">
        <Dropdown show={showDropdown} onToggle={() => setShowDropdown(!showDropdown)}>
          <Dropdown.Toggle variant="danger" id="dropdown-basic">
            Offline
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item disabled>No active user data available.</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  }

  const userMap = activeUsers as UserStatusMap;

  const onlineUsers = Object.entries(userMap).filter(([_, [online]]) => online);

  const formatTimestamp = (timestamp: string) => {
    const seconds = parseFloat(timestamp);
    if (isNaN(seconds)) return "Unknown time";
    const date = new Date(seconds * 1000);
    return date.toLocaleString();
  };

  return (
    <div className="active-user-display">
      <Dropdown show={showDropdown} onToggle={() => setShowDropdown(!showDropdown)}>
        <Dropdown.Toggle variant="success" id="dropdown-basic">
            {onlineUsers.length} Active User
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {Object.entries(userMap).map(([email, [online, lastSeen]]) => (
            <Dropdown.Item key={email} className="d-flex flex-column">
              <div className="d-flex align-items-center">
                <span className="me-2">{online ? '🟢' : '🔴'}</span>
                {userEmail === email ? <span>{email} (Current User)</span> :  <span>{email}</span>}
              </div>
              {!online && (
                <small className="text-muted ms-4">
                  Last seen: {formatTimestamp(lastSeen)}
                </small>
              )}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default ActiveUserDisplay;
